module.exports = __webpack_public_path__ + "static/media/SMBracket_element@2x.b3eec3af.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sportsmate/SMBracket_element@2x.png
// module id = 170
// module chunks = 0